<template>
    <transition name="toggleContentComponent">
        <article class="livestreamPlayer " v-if="ready">
            <iframe ref="youtube" if="properties.embedURL !== ''" :src="embedURL" frameborder="0"
                allowfullscreen="allowfullscreen" mozallowfullscreen="mozallowfullscreen"
                msallowfullscreen="msallowfullscreen" oallowfullscreen="oallowfullscreen"
                webkitallowfullscreen="webkitallowfullscreen"
                allow="autoplay;encrypted-media">
            </iframe>


            <button class="close" @click="closeComponent()">
                <img src="@/assets/img/ui/box-close.svg" />
            </button>
            <figure>
                <img src="@/assets/img/ui/liveplayer-label-bg.svg">
                <span> <img src="@/assets/img/ui/Icon-Livestream_LivestreamFrame.gif">LIVE</span>
            </figure>
        </article>
    </transition>
</template>

<script>
export default {
    props: [
        "properties",
        "pageData",
        "slug"
    ],
    data() {
        return {
            ready: false,
            youtubeID: '',
        }
    },
    created() {
        if (this.properties.embedURL !== '')
            this.youtubeID = this.getYoutubeID(this.properties.embedURL);
    },
    mounted() {
        this.ready = true;
        app.api.Utils.muteAudioManager();
    },
    methods: {
        getYoutubeID(url) {
            var regExp = /^.*(youtu.be\/|v\/|u\/\w\/|embed\/|watch\?v=|&v=)([^#&?]*).*/;
            var match = url.match(regExp);
            return (match && match[2].length === 11) ? match[2] : null;
        },
        openWorldMap() {
            app.api.PageManager.openContentComponentFromID(this.properties.worldMapID);
        },

        closeComponent() {

            // sound if closed
            app.api.Utils.unmuteAudioManager();

            this.$emit("closeComponent", this.slug);

            // custom feature: open specified content when this closes
            if (this.$store.getters.getPendingContentId) {
                let _this = this;
                setTimeout(() => {
                    console.log("PENDING CONTENT");
                    app.api.PageManager.openContentComponentFromID(_this.$store.getters.getPendingContentId);
                    // only once!
                    _this.$store.commit('setPendingContentId', null);
                }, 750);
            }


        }
    },

    computed: {
        isYoutubeLink() {
            return !!this.getYoutubeID(this.properties.embedURL);
        },
        embedURL() {
            if (this.isYoutubeLink) {
                return `https://www.youtube.com/embed/${this.getYoutubeID(this.url)}`;
            } else {
                return this.properties.embedURL; // Use the original URL if it's not a YouTube link
            }
        },
        youtubeUrl() {
            return `https://www.youtube.com/embed/${this.youtubeID}`
        },

    }
};
</script>

<style lang="scss">
.livestreamPlayer {

    // iframe should be 1480 x 833 px

    width: 1494px;
    height: 847px;
    border: var(--light-grey) 7px solid;
    border-radius: 10px;
    display: flex;
    justify-content: center;


    &.fullscreenVideo {
        height: 100%;
        width: 100%;
    }

    &>video,
    &>iframe {
        height: 100%;
    }

    iframe {
        //   position: absolute;
        width: 100%;
    }

    button.close {
        position: absolute;
        right: -2px;
        top: -1px;
    }

    figure {
        position: absolute;
        bottom: -5px;

        span {

            position: absolute;
            display: flex;
            color: #3C3C3C;
            font-family: 'Arla Strong';
            font-size: 20px;
            gap: 10px;
            bottom: 4px;
            margin-left: -5px;
            justify-content: center;
            width: 100%;

            img {
                width: 23px;
                height: 17px;
            }
        }
    }

}
</style>